<template>
    <div class="withdrawalCurrency">
        <div class="choose_currency">
            <div class="heading">
                <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_currency%402x.png"
                    alt="">
                <div class="title">{{ $t('withdraw.text38') }}</div>
                <div class="web-account">
                    <el-dropdown trigger="click">
                        <div class="web-account-item">
                            {{$t('withdraw.text74')}}：<span>{{ activeWebAccount.id }}({{ activeWebAccount.name }})</span><i
                                class="iconfont icon-more_gray"></i>
                            <el-icon class="el-icon--right">
                            </el-icon>
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="item in webList" :key="item.id"
                                    @click="changeWebAccount(item)">{{ item.id
                                    }}({{ item.name }})</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
            <div class="currency_list">
                <p>{{ $t('withdraw.text39') }}</p>
                <ul>
                    <li v-for="item in currencyList">
                        <div class="li_left">
                            <img :src="item.currencyCategory.icon" alt="">
                            <div class="name">{{ item.currencyCategory.name }}</div>
                        </div>
                        <i class="iconfont icon-icon_jump_dack"></i>
                        <div class="payinChannelList">
                            <div class="payinChannelItem" v-for="ele in item.payinChannelList"
                                @click="gotoGetPayType(item,ele)">
                                {{ ele.name }}
                                <i class="iconfont icon-icon_more_gray1"></i>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="empty" v-if="currencyList.length == 0">
                    <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_no_data%402x.png"
                        alt="">
                    <p>{{ $t('trade.text66') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {
    ref, computed
} from 'vue';
import apiService from '@/api/request';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default {
    name: 'withdrawalCurrency',
    components: {

    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const activeWebAccount = ref({});
        const currencyList = ref([]);//币种列表
        const webList = ref([]);
        const loading = ref(false);

        WithdrawPayInChannelList();
        function WithdrawPayInChannelList() {
            loading.value = true;
            //获取币种
            apiService.WithdrawPayInChannelList().then(res => {
                loading.value = false;
                console.log('GetPayCurrencyCategoryList', res);
                if (res.status == 1) {
                    currencyList.value = res.data.list;
                }
            })
        }


        function gotoGetPayType(item,ele) {
            router.push({
                name: 'withdrawal',
                query: {
                    payType: item.currencyCategory.payType,
                    payId: ele.payId,
                    fundAccountId:activeWebAccount.value.id,
                    fundAccountName:activeWebAccount.value.name,
                }
            })
        }

        GetAllAccountList();
        //获取web账号
        function GetAllAccountList() {
            apiService.GetAllAccountList().then(res => {
                if (res.status == 1) {
                    webList.value = res.data.webList;
                    activeWebAccount.value = webList.value[0]
                }
            })
        }
        function changeWebAccount(item) {
            activeWebAccount.value = item;
        }
        return {
            currencyList,
            gotoGetPayType,
            activeWebAccount,
            webList,
            loading,
            changeWebAccount
        }
    }
}
</script>
<style lang="less" scoped>
.withdrawalCurrency {
    .heading {
        padding: 12px 30px;
        font-size: 18px;
        display: flex;
        justify-content: left;
        align-items: center;
        border-bottom: 1px solid @border-color-base;
        /*no*/
        position: relative;

        img {
            display: block;
            width: 20px;
            height: 20px;
            margin-top: 2px;
            margin-right: 10px;
        }

        .title {
            font-weight: 500;
        }

        .web-account {
            font-size: 14px;
            position: absolute;
            right: 16px;
            top: 16px;

            .web-account-item {
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            span {
                color: @primary-color;
            }

            i {
                font-size: 6px;
                margin-left: 6px;
            }
        }
    }

    .currency_list {
        padding: 20px 30px;

        p {
            color: #51B4F1;
            font-size: 12px;
            text-align: left;
        }

        ul {
            margin-top: 30px;

            li {
                border: 2px solid #F2F4FB;
                padding: 10px 16px;
                border-radius: 10px;
                margin-bottom: 30px;

                &:nth-child(odd) {
                    margin-right: 40px;
                }

                cursor: pointer;

                .li_left {
                    display: flex;
                    justify-content: left;
                    align-items: center;

                    img {
                        width: 32px;
                        height: 32px;
                    }

                    .name {
                        font-size: 16px;
                        margin-left: 16px;
                    }
                }

                .iconfont {
                    font-size: 12px;
                    color: #BEC2CA;
                }

                .payinChannelItem {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-left: 48px;
                    height: 55px;
                    line-height: 55px;
                    border-bottom: 1px solid #F2F4FB;

                    &:last-child {
                        border: none;
                    }
                }
            }
        }

        .empty {
            padding-top: 80px;
            text-align: center;

            img {
                width: 70px;
            }

            p {
                text-align: center;
                font-size: 14px;
                color: #979DAB;
            }
        }
    }
}
</style>